import React, {useContext} from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {ThemeContext} from "../../context/ThemeContext";


const BarChartComponent = ({data}) => {
    const { isDarkMode } = useContext(ThemeContext);

    const colors = !isDarkMode ? ["#C2000F","#5D8F15"]:["#F95E64","#62A575"];

    return (
        <ResponsiveContainer width="100%" height={200}>
            <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="sentiment" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="this_week" fill={colors[1]} />
                <Bar dataKey="last_week" fill={colors[0]} />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default BarChartComponent;
